export default __webpack_public_path__ + "static/media/erro.5b14ad87.svg";